export default __webpack_public_path__ + "static/media/project_banner.e9911865.jpg";